import React from 'react';
import { hot, type EntryPoint } from 'repluggable';

import { createA11yEditorWizardPanel } from './create-a11y-wizard-panel';
import { ExperimentsAPI } from '@wix/editorx-core-api';
import { A11yWizardDuplexerAPI } from '@wix/a11y-adapters/studio';
import { A11yWizardDuplexerAPIEntry } from '../common/a11y-wizard-duplexer-api';
import {
  A11yWizardStateAPI,
  A11yWizardStateAPIEntry,
} from '../common/a11y-wizard-state-api';
import {
  A11yAdapterApiKey,
  EditorAPIKey,
  EditorParamsApiKey,
} from './a11y-editor-wizard-api-key';

export const A11yEditorWizardEntry: EntryPoint = {
  name: 'a11y-editor-wizard-entry',

  layer: 'UI',

  getDependencyAPIs: () => [
    A11yAdapterApiKey,
    EditorAPIKey,
    ExperimentsAPI,
    EditorParamsApiKey,
    A11yWizardStateAPI,
    A11yWizardDuplexerAPI,
  ],

  declareAPIs: () => [],

  attach: () => {},

  extend: (shell) => {
    const a11yWizardAdapterAPI = shell.getAPI(A11yAdapterApiKey);

    const Component = createA11yEditorWizardPanel(shell);

    a11yWizardAdapterAPI.contributePanel(shell, () => <Component />);
  },

  detach: (shell) => {
    const a11yWizardDuplexerAPI = shell.getAPI(A11yWizardDuplexerAPI);
    a11yWizardDuplexerAPI.disconnect();
  },
};

export const A11yEditorWizardPackage: EntryPoint[] = hot(module, [
  A11yEditorWizardEntry,
  A11yWizardStateAPIEntry,
  A11yWizardDuplexerAPIEntry,
]);
